// Respuesta de api2 al subir el documento (POST /booking/docs/{pax}). Cuando el hotel tiene el
// escaneo de documentos, api2 analiza el frente y devuelve el motivo ya escrito en el idioma que
// le pedimos con `lang`: un rechazo trae { code, message } en el 400 y una subida aceptada con
// advertencia (documento vencido hace menos de 12 meses) trae { warning: { code, message } }.

const API_LANGUAGES = ["es", "en", "pt"];

// Idioma del motivo para api2: es, en o pt. Cualquier otro, en: igual que la interfaz
// (index.js cae a los mensajes en inglés).
export function apiLanguage(lng) {
  const value = String(lng || "").slice(0, 2).toLowerCase();
  return API_LANGUAGES.includes(value) ? value : "en";
}

function text(value) {
  return typeof value === "string" && value.trim() !== "" ? value.trim() : null;
}

// Motivo de un rechazo.
// - `transient`: la foto no tiene nada malo (sin respuesta, 429 o 5xx, o el string que lanza el
//   interceptor por un 2xx con response 0 sin código, ej. falló la subida a S3): se reintenta
//   con la misma foto. `retryAfter` (segundos) viene del 429.
// - Sólo se usa el mensaje de api2 si trae `code`: sin código es la respuesta vieja ("El
//   documento no es válido", siempre en español) y conviene el texto traducido del front.
export function uploadRejection(err) {
  const response = err && err.response;
  const status = response && response.status;
  const data = response && response.data;
  if (!response || status === 429 || status >= 500) {
    const retryAfter =
      status === 429 && data && Number(data.retry_after) > 0
        ? Number(data.retry_after)
        : null;
    return { code: null, message: null, transient: true, retryAfter };
  }
  if (!data || typeof data !== "object")
    return { code: null, message: null, transient: false, retryAfter: null };
  const code = text(data.code);
  return {
    code,
    message: code ? text(data.message) : null,
    transient: false,
    retryAfter: null
  };
}

// Advertencia de una subida aceptada, o null.
export function uploadWarning(result) {
  const warning = result && result.warning;
  if (!warning || typeof warning !== "object") return null;
  const message = text(warning.message);
  return message ? { code: text(warning.code), message } : null;
}
